import React, { Suspense } from "react";
import { TeamFeatureItem } from "./TeamFeatureItem";
import { AHIcon, AHText, AHTextFonts, Box, TodoPrioIcon } from "arkh";
import { SignalUnreadLabel } from "./SignalUnreadLabel";
import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";
import { graphql, useFragment } from "react-relay";
import { TeamFeatureBarSignalItem_team$key } from "./__generated__/TeamFeatureBarSignalItem_team.graphql";

function TeamFeatureBarSignalItemComponent(props: {
  unreadCount: number;
  activeCount: number;
  hasHighPrioritySignals: boolean;
  isGrid: boolean;
  onOpenFeature: (feature: string) => void;
}) {
  const intl_tokens = useIntlTokens();
  return (
    <TeamFeatureItem
      isGrid={props.isGrid}
      highlighted={props.unreadCount > 0}
      count={props.activeCount}
      icon={<AHIcon type="signal" size="medium" />}
      right={
        <Box style={{ flexDirection: "row", alignItems: "center" }}>
          {props.unreadCount > 0 ? (
            <AHText
              color="text-secondary"
              font={AHTextFonts.REGULAR}
              type="subtitle"
            >
              <SignalUnreadLabel unreadCount={props.unreadCount} />
            </AHText>
          ) : null}
          {props.hasHighPrioritySignals ? (
            <Box spaceLeft="xsmall">
              <TodoPrioIcon priority="HIGH" />
            </Box>
          ) : null}
        </Box>
      }
      title={intl_tokens.Signals}
      onPress={() => {
        props.onOpenFeature("SIGNAL");
      }}
    />
  );
}
export function TeamFeatureBarSignalItem(props: {
  feature: TeamFeatureBarSignalItem_team$key;
  isGrid: boolean;
  onOpenFeature: (feature: string) => void;
}) {
  return (
    <Suspense
      fallback={
        <TeamFeatureBarSignalItemComponent
          unreadCount={0}
          activeCount={0}
          hasHighPrioritySignals={false}
          isGrid={props.isGrid}
          onOpenFeature={props.onOpenFeature}
        />
      }
    >
      <InnerTeamFeatureBarSignalItem {...props} />
    </Suspense>
  );
}

function InnerTeamFeatureBarSignalItem(props: {
  feature: TeamFeatureBarSignalItem_team$key;
  isGrid: boolean;
  onOpenFeature: (feature: string) => void;
}) {
  const item = useFragment(
    graphql`
      fragment TeamFeatureBarSignalItem_team on SignalTeamFeature {
        unreadCount
        activeCount
        signalUnreadCount(employeeId: $employeeId)
        hasHighPrioritySignals
      }
    `,
    props.feature
  );

  return (
    <TeamFeatureBarSignalItemComponent
      unreadCount={item.signalUnreadCount ?? 0}
      activeCount={item.activeCount}
      hasHighPrioritySignals={item.hasHighPrioritySignals}
      isGrid={props.isGrid}
      onOpenFeature={props.onOpenFeature}
    />
  );
}
